export const DEFAULT_COLUMN_WIDTH = 150;
export const MIN_COLUMN_WIDTH = 50;
export const MAX_COLUMN_WIDTH = 500;
